export const annotationsJson = [
    {
        annotationDisplayName: "Date created",
        annotationName: "date_created",
        description: "Date and time file was created",
        type: "Date/Time",
    },
    {
        annotationDisplayName: "Cell line",
        annotationName: "cell_line",
        description: "AICS cell line",
        type: "Text",
    },
    {
        annotationDisplayName: "Cells are dead",
        annotationName: "cell_dead",
        description: "Does this field contain dead cells",
        type: "Yes/No",
    },
    {
        annotationDisplayName: "Is matrigel hard?",
        annotationName: "matrigel_hardened",
        description: "Whether or not matrigel is hard.",
        type: "Yes/No",
    },
    {
        annotationDisplayName: "Objective",
        annotationName: "objective",
        description: "Imaging objective",
        type: "Number",
    },
];
